module.exports = __webpack_public_path__ + "img/DiNapoli-1N.4e8389f0.png";